import _, { escapeRegExp } from 'lodash';
import { ISearchProduct as IProduct } from "../interface";

const filterProductByName = (products: IProduct[], value: string) => {           
  return value.length < 2 ? [] : products.filter((d) => {
    return d.name.toLowerCase().search(escapeRegExp(value.toLowerCase().replace('castrol', '').trim())) >= 0;
  });
};

export default filterProductByName;
